export const slugify = (text) => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
};

export const createProductSlug = (device) => {
  return `${slugify(device.name)}-${device.id}`;
};

export const createSlug = (text = "") => {
  return text
    ?.toString()
    .toLowerCase()
    .replace(/way4track/gi, "")
    .trim()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
};
